import Vue from 'vue'

/* 天地图 本地引入 */
/* 请注意天地图sdk_key https://api.tianditu.gov.cn/api?v=4.0&tk=0b9199b328f9862d3ec9c14d8c020f19 */
require('@/assets/js/Tmap.js')

import '@/styles/element-ui/theme/index.css'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import '@/styles/index.scss' // global css
import '@/styles/font.scss'// 数字字体
import '@/assets/fxicon/iconfont'

// TWcss
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import 'tailwindcss/tailwind.css'
import './tailwind.css'

// import 'lib-flexible'

import App from './App'
import store from './store'
import router from './router'
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, { ak: 'HAqkbsSlb0635AGkGsVfgeZy6iachS4f' })
import './rem.js'
import moment from 'moment' // 导入文件
Vue.prototype.$moment = moment
Vue.use(ElementUI, {
  locale,
  size: 'mini'
})
// import BaiduMap from 'vue-baidu-map-3x'
// Vue.use(BaiduMap, {
//   ak: 'T4C8czQMTlIW5nf3cYjOSbnTOzZ1hiTA', // 替换为实际AK
//   v: '3.0', // 指定API版本
//   type: 'WebGL'
// })
// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload, {
//   // error: require('../public/images/img_default.png'),
//   // loading: require('../public/images/image_loading.png')
// })

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
// 全局注册侧边栏
Vue.component('SideBox', () => import('@/components/SideBox'))
// 全局注册分页
Vue.component('Pagination', () => import('@/components/Pagination'))
// 全局注册操作按钮
Vue.component('ButtonOption', () => import('@/components/ButtonOption'))

// 全局注册通用对象分类列表
Vue.component('ObjectClassList', () => import('@/components/upms/ObjectClassList'))

// 全局注册列表选择
Vue.component('ObjectTable', () => import('@/components/upms/ObjectTable'))

// 全局注册区域选择列表
Vue.component('Arealist', () => import('@/components/upms/Area_list'))

// 全局注册设备分类管理上级
Vue.component('superior', () => import('@/components/upms/superior'))

// 全局注册模态对话框
Vue.component('ModelDialog', () => import('@/components/ModelDialog'))

// 全局注册表格工具栏
Vue.component('TableToolbar', () => import('@/components/TableToolbar'))

// 全局注册图片logo上传
Vue.component('SingleImageUpload', () => import('@/components/upload/SingleImageUpload'))
Vue.component('SimpleUploader', () => import('@/components/upload/SimpleUploader'))
Vue.component('FileItem', () => import('@/components/upload/FileItem'))

Vue.component('UserSelector', () => import('@/views/components/bpmn/UserSelector'))
// 全局分配设备列表
// Vue.component('monitorFactor', () => import('@/components/upms/monitorFactor'))

/*
* 公共JS
*/

/**
 * 公共弹框
 */
Vue.prototype.msgSuccess = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}
Vue.prototype.msgError = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'error' })
}
Vue.prototype.msgWarning = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'warning' })
}
// import '@/utils/global'
// import '@/utils/constants'
// import '@/utils/directives'
// import '@/utils/component'
import '@/utils/common/validate'
import '@/utils/common/filters'
import '@/utils/global'
import '@/utils/filters'

import * as utils from '@/utils/utils'
Vue.prototype.utils = utils
import defaultSettings from '@/settings'
Vue.prototype.defaultSettings = defaultSettings

/**
 * 系统错误捕获
 */
Vue.config.errorHandler = (err, vm) => {
  console.log('JS异常')
  console.error(err)
  // ElementUI.Notification({
  //   type: 'error',
  //   title: 'JS异常',
  //   dangerouslyUseHTMLString: true,
  //   message: '<m style="color:red">按F12查看错误信息</m><br>请将错误信息发送给管理员进行处理'
  // })
}
Vue.prototype.handleImageError = function(e) {
  let title
  if (e.target.title && e.target.title) {
    title = e.target.title.substring(0, 1)
  }
  e.target.src = Vue.prototype.common.generateTextPictures(title)
}

/**
 * SVG组件相关资源
 */
/* import ECharts from 'vue-echarts'
Vue.component('v-chart', ECharts)*/
// import '@/icons'
import ExportDropDown from './components/ExportDropDown.vue'
Vue.component('ExportDropDown', ExportDropDown)
import DataDictSelect from './components/DataDictSelect.vue'
Vue.component('DataDictSelect', DataDictSelect)
store.dispatch('loadNoramlSvgIcons').then((res) => {
  res.forEach(f => {
    const componentInfo = {
      template: f.template,
      props: f.props
    }
    Vue.component(f.type, componentInfo)
  })
})
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

// import 'default-passive-events'
import formCreate from '@form-create/element-ui'
import FcDesigner from '@form-create/designer'

Vue.use(formCreate)
Vue.use(FcDesigner)
import 'bpmn-js/dist/assets/diagram-js.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css'
Vue.prototype.$FILE_SERVER = 'http://47.104.247.47:10013/' + Vue.prototype.constants.WORKFLOW
Vue.prototype.formCreaterUploadSuccess = function(e, t) {
  if (e.code === 200) {
    t.url = e.data.uuid
  } else {
    this.$message({ showClose: true, message: e.data == null ? e.message : e.data, type: 'warning' })
  }
}

Vue.config.productionTip = false
const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
export default app
